<script lang="ts">
    import DefaultSlide from "./DefaultSlide.svelte"

    let {
        slide,
    }: {
        slide: SplittedHeroRowBlock
    } = $props()
    const cnt = slide.content

    type SlideLike = {
        page_reference?: Slide["page_reference"]
        title?: string
    }

    function normalizePageReference(ref?: Slide["page_reference"]) {
        if (!ref) return null
        if (Array.isArray(ref)) return ref.find(Boolean) ?? null

        if (typeof ref === "string") {
            try {
                const parsed = JSON.parse(ref)
                if (Array.isArray(parsed)) return parsed.find(Boolean) ?? null
            } catch {
                /* ignore */
            }

            const cleanedRef = ref
                .replace(/^page:\/\//, "")
                .replace(/^file:\/\//, "")
                .replace(/[\[\]\(\)'"`]/g, "")
                .trim()

            return cleanedRef || null
        }

        return null
    }

    function getSlideFingerprint(slide?: SlideLike) {
        if (!slide) return null
        const pageRef = normalizePageReference(slide.page_reference)
        if (pageRef) return pageRef
        if (slide.title?.trim()) return slide.title.trim().toLowerCase()
        return null
    }

    function dedupeSecondarySlides(slides: Slide[] = [], primaryKey: string | null = null) {
        const seen = new Set<string>()
        if (primaryKey) seen.add(primaryKey)

        return slides
            .filter((secondary): secondary is Slide => Boolean(secondary))
            .filter((secondary) => {
                const fingerprint = getSlideFingerprint(secondary)
                if (fingerprint && seen.has(fingerprint)) return false
                if (fingerprint) seen.add(fingerprint)
                return true
            })
    }

    const secondarySlides = $derived(dedupeSecondarySlides(cnt.secondary, getSlideFingerprint(cnt)))
    const secondaryOne = $derived(secondarySlides[0])
    const secondaryTwo = $derived(secondarySlides[1])
</script>

<section>
    <div class="primary">
        <DefaultSlide slide={cnt} type="primary" splitted={true} />
    </div>
    {#if secondaryOne}
        <div class="secondary-1">
            <DefaultSlide slide={secondaryOne} type="secondary" splitted={true} number={1} />
        </div>
    {/if}
    {#if secondaryTwo}
        <div class="secondary-2">
            <DefaultSlide slide={secondaryTwo} type="secondary" splitted={true} number={2} />
        </div>
    {/if}
</section>

<style lang="less">
    @import "../../../../css/variables.less";
    section {
        display: grid;
        position: relative;
        height: 100%;
        width: 100%;
        & > div {
            position: relative;
            height: 100%;
            overflow: hidden;
            width: 100%;
        }
        grid-template-columns: 1fr 1fr;
        .primary {
            grid-column: span 2;
            grid-row: span 1;
        }
        .secondary-1 {
            grid-column: span 1;
            grid-row: span 1;
        }
        .secondary-2 {
            grid-column: span 1;
            grid-row: span 1;
        }
        @media @desktop_large {
            gap: 1px;
            grid-template-columns: repeat(3, 1fr);
            grid-template-rows: repeat(2, 1fr);

            .primary {
                grid-column: span 2;
                grid-row: span 2;
            }

            .secondary-1 {
                grid-column: span 1;
                grid-row: span 1;
            }

            .secondary-2 {
                grid-column: span 1;
                grid-row: span 1;
            }
        }
    }
</style>
